(() => {
  const LEGACY_BLOCK_ID =
    'shopify-block-AUU9qQ2pKeW1aNVhjR__klaviyo_email_marketing_sms_form_embed_block_7iJfWd';
  const FORM_SELECTOR = "[data-testid='klaviyo-form-R39vbc'], .klaviyo-form-R39vbc";
  const page = document.querySelector("main[data-template='page.contact']");
  const formRoot = page?.querySelector(FORM_SELECTOR);
  const block = formRoot?.closest('.shopify-app-block');

  if (!block) return;

  if (block.id !== LEGACY_BLOCK_ID) {
    block.id = LEGACY_BLOCK_ID;
  }

  const messageInputSelector = "[id*='Message_']";
  const componentSelector = "[data-testid='form-component']";
  const submitButtonSelector = "button[type='button']";

  const syncInputState = (input, component) => {
    component.dataset.messageEmpty = input.value.trim() ? 'false' : 'true';
  };

  const upgradeMessageInputToTextarea = (field) => {
    if (!(field instanceof HTMLInputElement)) return field;

    const textarea = document.createElement('textarea');

    for (const { name, value } of Array.from(field.attributes)) {
      if (name === 'type') continue;
      textarea.setAttribute(name, value);
    }

    textarea.value = field.value;
    textarea.rows = 4;
    textarea.style.resize = 'none';
    textarea.style.overflowY = 'auto';
    field.replaceWith(textarea);
    return textarea;
  };

  const bindMessageInput = (field) => {
    const input = upgradeMessageInputToTextarea(field);
    if (!(input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement)) return;
    if (input.dataset.klaviyoMessagePlaceholderBound === 'true') return;

    const component = input.closest(componentSelector);
    if (!component) return;

    component.dataset.klaviyoMessageField = 'true';
    component.dataset.fakePlaceholder =
      input.getAttribute('placeholder') || 'Let us know how we can assist you...';
    component.dataset.messageFocused = 'false';
    syncInputState(input, component);

    input.addEventListener('focus', () => {
      component.dataset.messageFocused = 'true';
    });

    input.addEventListener('blur', () => {
      component.dataset.messageFocused = 'false';
      syncInputState(input, component);
    });

    input.addEventListener('input', () => {
      syncInputState(input, component);
    });

    input.addEventListener('change', () => {
      syncInputState(input, component);
    });

    input.dataset.klaviyoMessagePlaceholderBound = 'true';
  };

  const bindMessageInputs = () => {
    block.querySelectorAll(messageInputSelector).forEach(bindMessageInput);
  };

  const bindSubmitButton = () => {
    const submitButton = block.querySelector(submitButtonSelector);
    if (!submitButton) return;

    submitButton.classList.add('bravo-btn', 'bravo-btn--primary');
    submitButton.setAttribute('data-aim', '');
  };

  bindMessageInputs();
  bindSubmitButton();

  const observer = new MutationObserver(() => {
    bindMessageInputs();
    bindSubmitButton();
  });

  observer.observe(block, { childList: true, subtree: true });
})();
